import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal, Horizon } from "../components/Reveal";
import { IMG } from "../data/images";
import { useLang } from "../i18n";

export const About = () => {
  const ref = useRef(null);
  const { t } = useLang();
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y1 = useTransform(scrollYProgress, [0, 1], [60, -60]);
  const y2 = useTransform(scrollYProgress, [0, 1], [-40, 70]);

  return (
    <section
      id="sobre-nosotros"
      data-testid="about-section"
      ref={ref}
      className="relative bg-[#F5EDE3] px-6 py-24 md:px-12 md:py-40"
    >
      <div className="mx-auto grid max-w-[1400px] items-center gap-16 lg:grid-cols-[1fr_1.05fr] lg:gap-24">
        <div>
          <Reveal>
            <p className="label text-[#8A6A4F]">{t.about.label}</p>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-6 max-w-[22ch] font-serif text-4xl font-light leading-[1.06] text-[#2B1E16] sm:text-5xl lg:text-6xl">
              {t.about.title}
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <div className="mt-10 max-w-[46ch] space-y-6 font-sans text-sm leading-relaxed text-[#2B1E16]/75 md:text-base">
              <p>
                {t.about.p1a}
                <strong className="font-medium text-[#2B1E16]">{t.about.p1strong}</strong>
                {t.about.p1b}
              </p>
              <p>{t.about.p2}</p>
              <p className="font-serif text-2xl italic text-[#8A6A4F] md:text-3xl">{t.about.quote}</p>
            </div>
          </Reveal>
          <div className="mt-12 max-w-sm">
            <Horizon />
          </div>
          <Reveal delay={0.3}>
            <dl className="mt-10 grid max-w-md grid-cols-3 gap-6">
              {t.about.stats.map(([k, v]) => (
                <div key={v}>
                  <dt className="font-serif text-2xl text-[#2B1E16] md:text-3xl">{k}</dt>
                  <dd className="mt-2 font-sans text-[10px] uppercase tracking-[0.2em] text-[#2B1E16]/50">{v}</dd>
                </div>
              ))}
            </dl>
          </Reveal>
        </div>

        <div className="relative h-[420px] sm:h-[560px] lg:h-[680px]">
          <motion.div
            style={{ y: y1 }}
            className="absolute start-0 top-0 w-[68%] overflow-hidden bg-[#2B1E16]/10"
          >
            <img
              src={IMG.interior}
              alt={t.about.altInterior}
              loading="lazy"
              className="h-[280px] w-full object-cover transition-transform duration-[2500ms] ease-out hover:scale-105 sm:h-[380px] lg:h-[460px]"
            />
          </motion.div>
          <motion.div
            style={{ y: y2 }}
            className="absolute bottom-0 end-0 w-[56%] overflow-hidden bg-[#2B1E16]/10 shadow-[0_30px_60px_-30px_rgba(43,30,22,0.45)]"
          >
            <img
              src={IMG.latte}
              alt={t.about.altLatte}
              loading="lazy"
              className="h-[240px] w-full object-cover transition-transform duration-[2500ms] ease-out hover:scale-105 sm:h-[320px] lg:h-[400px]"
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
};
